import { render, staticRenderFns } from "./PanoViewerContainer.vue?vue&type=template&id=2da7f742&"
import script from "./PanoViewerContainer.vue?vue&type=script&lang=js&"
export * from "./PanoViewerContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2da7f742')) {
      api.createRecord('2da7f742', component.options)
    } else {
      api.reload('2da7f742', component.options)
    }
    module.hot.accept("./PanoViewerContainer.vue?vue&type=template&id=2da7f742&", function () {
      api.rerender('2da7f742', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/panoViewer/PanoViewerContainer.vue"
export default component.exports